import { HTTP } from "./HttpService"

export class CatalogFetcher {
  static queryPublic(sellerId, cursor, batchSize, params) {
    const base = "/api/seller/" + sellerId + '/public_products?'
    return CatalogFetcher.query(base, cursor, batchSize, params)
  }

  static queryCatalog(sellerId, catalogId, cursor, batchSize, params) {
    params.catalogId = catalogId
    const base = "/api/sellers/" + sellerId + "/products/?"
    return CatalogFetcher.query(base, cursor, batchSize, params)
  }

  static queryAvailable(sellerId, cursor, batchSize, params) {
    const base = "/api/sellers/" + sellerId + "/products/?"
    return CatalogFetcher.query(base, cursor, batchSize, params)
  }

  static query(base, cursor, batchSize, params) {
    const queryParams = new URLSearchParams({ per_page: batchSize });
    if (cursor) { queryParams.append("after", cursor) }

    const mappings = [
      { key: "unavailable", name: "unavailable", value: "true"  },
      { key: "categories", name: "categories", join: "|" },
      { key: "producers", name: "producers", join: "|" },
      { key: "collections", name: "collections", join: "|" },
      { key: "count", name: "count", value: "true" },
      { key: "localOnly", name: "local_only", value: "true" },
      { key: "buyerId", name: "buyer_id" },
      { key: "catalogId", name: "private_catalog_id" },
      { key: "inStockOn", name: "in_stock_on" },
      { key: "isFeatured", name: "featured", value: "true" },
      { key: "productSlug", name: "product_slug" },
      { key: "text", name: "text" },
      { key: "sortBy", name: "sort_by" }
    ];

    for (const { key, name, value, join } of mappings) {
      const param = params[key];

      if (param != null && param !== false) {
        const val = value ?? (Array.isArray(param) && join ? param.join(join) : param);
        if (val != '') {
          queryParams.append(name, val);
        }
      }
    }

    return HTTP.get(`${base}${queryParams.toString()}`);
  }
}
